export default __webpack_public_path__ + "static/media/KOD0123-min.ae909052.webp";